function submitForm() {
    var value = $('#filter-input')[0].value;
    document.getElementById('filter-input-hidden').value = value;
    $("#inventory-filters").submit();
}

function submitFormMobile() {
    var value = $('#filter-input-mobile')[0].value;
    document.getElementById('filter-input-hidden').value = value;
    $("#inventory-filters").submit();
}

$(function () {
    var firstPage = 1;

    $('.select-filter').on('change', function () {
        $('#page-input').val(firstPage);
        submitForm();
    });

    var submit = debounce(function () {
        submitForm();
    }, 250);

    $('.input-filter').on('keyup', function () {
        $('#page-input').val(firstPage);
        submit();
    });

    $('.checkbox-filter').on('change', function () {
        $('#page-input').val(firstPage);
        submitForm();
    });

    $('#filter-search-icon').on('click', function () {
        $('#page-input').val(firstPage);
        submitForm();
    });

    $('#filter-search-icon-mobile').on('click', function () {
        $('#page-input').val(firstPage);
        submitFormMobile();
    });

    $('#filter-input').on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#page-input').val(firstPage);
            submitForm();
        }
    });

    $('#filter-input-mobile').on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $('#page-input').val(firstPage);
            submitFormMobile();
        }
    });
   
    $('.apply-promo-code-grid-view').on('click', function () {
        submitForm();
    });

    setTimeout(function () {
        $('.error-promo-code').fadeOut();
    }, 5000);

    // register datepicker
    registerPikaday(submitForm);

    // wire up pagination
    paginate(document.getElementById('page-input'), $('#page-size-filter'), submitForm);
});

$('.inventory .reset-filters').on('click', function () {
    window.location = '/Product/Inventory';
});

$('.fav-true').on('click', function (e) {
    var row = $(e.currentTarget).closest('.favorite-product');
    var nameId = row.find('.favorite-nameId').text();
    console.log(nameId);

    $.ajax('/Favorites/' + nameId, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        type: 'DELETE',

        success: function (response) {
            window.location.reload();
        }
    });
});

$('.fav-false').on('click', function (e) {
    var row = $(e.currentTarget).closest('.favorite-product');
    var nameId = row.find('.favorite-nameId').text();

    $.ajax('/Favorites/' + nameId, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        type: 'POST',

        success: function (response) {
            window.location.reload();
        }
    });
});